import {FeedRuleType} from '../locationFeed.enums';
import {FeedMappingRule} from '../locationFeed.types';

function getFeedRuleKey(ruleType: FeedRuleType) {
  return {
    [`${FeedRuleType.Capitalize}`]: 'capitalization',
    [`${FeedRuleType.Replace}`]: 'replace',
    [`${FeedRuleType.ReplaceRegex}`]: 'regexReplace',
    [`${FeedRuleType.DefaultValue}`]: 'defaultValue',
    [`${FeedRuleType.OverrideValue}`]: 'overrideValue',
    [`${FeedRuleType.RegexExtract}`]: 'regexExtract',
    [`${FeedRuleType.RemoveImagesBackground}`]: 'removeBackground',
  }[ruleType] as keyof FeedMappingRule;
}

export default getFeedRuleKey;
